// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/l1CarsSellPage.twh.nlbe.scss';

// i18n
import i18n from '../../i18n/nl-BE';

import l1CarsSellPage from './l1CarsSellPage';

l1CarsSellPage(i18n);
